import React from 'react'
import PropTypes from 'prop-types'

import Tooltip from 'Pods/Shared/Tooltip'
import Icon from 'Pods/Shared/Icon/Icon'
import Dropdown from 'Pods/Shared/Dropdown'
import VideoModal from 'Pods/Shared/TutorialWidget/Components/VideoModal'

import CollectionCreationModal from './CollectionCreation/CollectionCreationModal'

class CollectionsButton extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      modalIsOpen: props.editableCollectionId !== '',
      tutorialModalIsOpen: false,
    }

    this.actionIsValid = this.actionIsValid.bind(this)
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.onAddToCollection = this.onAddToCollection.bind(this)
    this.triggerTutorialModal = this.triggerTutorialModal.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ modalIsOpen: nextProps.editableCollectionId !== '' })
  }

  actionIsValid() {
    const collections = this.props.selectedItems.filter(item => item.type === 'collections')
    const unpublishedItems = this.props.selectedItems.filter(item => item.attributes.status !== 'published' && item.type === 'models')
    const legacyCollections = this.props.selectedItems.filter(item => item.attributes.legacyCollection === true && item.type === 'models')

    if (collections.length > 0 || unpublishedItems.length > 0 || legacyCollections.length > 0) {
      if (collections.length > 0 || legacyCollections.length > 0) {
        const allCollections = collections.concat(legacyCollections)
        const collectionsTitles = allCollections.map((collection, index) => `${index ? ' ' : ''}"${collection.attributes.title}"`)

        App.events.publish(
          'app:notification:flash:error',
          `Existing pack cannot be included as a part of another pack. Please unselect ${collectionsTitles} to continue.`
        )
      }

      if (unpublishedItems.length > 0) {
        const itemsTitles = unpublishedItems.map((item, index) => `${index ? ' ' : ''}"${item.attributes.title}"`)

        App.events.publish(
          'app:notification:flash:error',
          `Only Published models can be included in packs. Please either unselect ${itemsTitles} or publish first.`
        )
      }

      return false
    }

    return true
  }

  openModal() {
    if (this.actionIsValid()) {
      this.setState({ modalIsOpen: true })
    }
  }

  closeModal() {
    this.setState({ modalIsOpen: false })
    this.props.editCollection('')
  }

  onAddToCollection() {
    if (this.actionIsValid()) {
      this.props.triggerAddToCollection()
    }
  }

  triggerTutorialModal() {
    this.setState(prevState => ({
      tutorialModalIsOpen: !prevState.tutorialModalIsOpen,
    }))
  }

  render() {
    const tooltipText = "Create packs of models you're already selling on CGTrader! Packs help you sell more to buyers who are looking for models with consistent quality and style."

    return (
      <div className="u-inline-block u-ml10 collections-dropdown">
        <Dropdown title="Packs" titleIcon={['fas', 'sitemap']}>
          <Tooltip
            tooltipClassName="tooltip--medium u-text-center"
            className="u-block"
            id="create-collection-btn-tooltip"
            content={tooltipText}
            place="left"
          >
            <div className={`collections-dropdown__item is-with-border ${this.props.isDisabled ? 'is-disabled' : ''}`} onClick={this.openModal}>
              Create a new pack
            </div>
          </Tooltip>

          <div
            className={`collections-dropdown__item is-with-border ${this.props.isAddingToCollection ? 'is-active' : ''} ${this.props.selectedItems.length === 0 ? 'is-disabled' : ''}`}
            onClick={this.onAddToCollection}
          >
            Add to existing pack
          </div>

          <div className="collections-dropdown__item dropdown-item--with-icon" onClick={this.triggerTutorialModal}>
            <span>About packs</span>
            <Icon type={['fab', 'youtube']} notSpaced />
          </div>
        </Dropdown>

        {this.state.modalIsOpen
          && (
          <CollectionCreationModal
            modalIsOpen={this.state.modalIsOpen}
            closeModal={this.closeModal}
            selectedItems={this.props.selectedItems}
            editableCollectionId={this.props.editableCollectionId}
            isAddingToCollection={this.props.isAddingToCollection}
          />
          )
        }

        {this.state.tutorialModalIsOpen && (
          <VideoModal
            modalIsOpen={this.state.tutorialModalIsOpen}
            closeModal={this.triggerTutorialModal}
            videoId="OnuAqmxqN64"
          />
        )}
      </div>
    )
  }
}

CollectionsButton.propTypes = {
  selectedItems: PropTypes.array.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  editableCollectionId: PropTypes.string.isRequired,
  editCollection: PropTypes.func.isRequired,
  isAddingToCollection: PropTypes.bool.isRequired,
  triggerAddToCollection: PropTypes.func.isRequired,
}

export default CollectionsButton
